/* eslint-disable jsx-a11y/no-redundant-roles */
import "./Home.css";
import Header from "../components/Header";
import pic1 from "../pics/5.png";
import logo from "../pics/logo.png";
import Typed from "typed.js";
import React, { useState, useEffect } from "react";
import { Parallax } from "react-scroll-parallax";
import { useParallax } from "react-scroll-parallax";
import { ParallaxController } from "parallax-controller";
// import Typist from "react-typist";
import linkedin from "../icons/linkedin.png"
import instagram from "../icons/instagram.png"
import email from "../icons/email.png"
import github from "../icons/github.png"
import twitter from "../icons/twitter.png"
import whatsapp from "../icons/whatsapp.png"
import codechef from "../icons/codechef.png"
// import { Parallax, ParallaxLayer } from '@react-spring/parallax'
import Contact from "./Contact";
import MyVerticallyCenteredModal from "./Contact";
import cv from "../utils/assests/cv.pdf"
import useSound from 'use-sound';
import ping from "../utils/sounds/ping.mp3";
import connect from "../utils/sounds/connect.mp3";
function Home() {
  const el = React.useRef(null);
  const typed = React.useRef(null);
  const [pingSound] = useSound(ping);
  React.useEffect(() => {
    const options = {
      strings: [" Web Developer", " Student", " Coder"],
      typeSpeed: 70,
      backSpeed: 60,
      loop: true,
      smartBackspace: true,
    };

    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, []);



  window.addEventListener('load', (event) => {
    console.log('page is fully loaded');
  });


   const linkedinlink= "https://www.linkedin.com/in/ankit-kumar-709b99162/";
   const githublink="https://github.com/ank-2222";
   const codecheflink="https://www.codechef.com/users/ank_222";
   const twitterlink="https://twitter.com/ankit_kum_22?t=m0Anyfg2HkPGdXtRGtwZrA&s=09";
   const emaillink="mailto:ankit.2222kumar2002@gmail.com";

   const [modalShow, setModalShow] = React.useState(false);
    
   const setModalShowHandler =()=>{
    setModalShow(true);
   }


  return (
    <div id="top">
      <div id="home-main" >
        <div><img id="logo" alt ="logo" src={logo}></img></div>
        <div id="header">
          <ul className="list">
            {/* <li><"#">Home</a></li> */}
            <li><a href="#about">About</a></li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#works">Works</a></li>
            <li><a href="#project">Projects</a></li>
            <li><a className="dowloadCv" href={cv}  download> My Resume</a></li>
            {/* <li><button onClick={()=>setContactButton(true)}>Contact</button></li> */}
          </ul>
        </div>

        <span id="home-social-head">
          <div className="home-social-icon"><a target='_blank' rel="noreferrer" onClick={pingSound} href={linkedinlink}><img src={linkedin}></img></a></div>
          <div className="home-social-icon"><a target='_blank' rel="noreferrer" onClick={pingSound} href={githublink}><img src={github}></img></a></div>
          <div className="home-social-icon"><a target='_blank' rel="noreferrer" onClick={pingSound} href={codecheflink}><img src={codechef}></img></a></div>

          <div className="home-social-icon"><a target='_blank' rel="noreferrer" onClick={pingSound} href={emaillink}><img src={email}></img></a></div>
          <div className="home-social-icon"><a target='_blank' rel="noreferrer" onClick={pingSound} href={twitterlink}><img src={twitter}></img></a></div>
          {/* <div className="home-social-icon"><a><img src={whatsapp}></img></a></div>
          <div className="home-social-icon"><a><img src={instagram}></img></a></div> */}
        </span>

        {/* <Header></Header> */}
        <div className="home-head">
          {/* <h2 className="home-text">Hi! I'am</h2> */}
          
          <h1 className="home-text" ><i>ANKIT KUMAR</i></h1>
          <div id="span">
            <span style={{ whiteSpace: "pre" }} ref={el} />
          </div>
        </div>
        <div className="home-head-p">
          <p>Lets Build Beautiful And Meaningful Things Together</p>
        </div>
        <div className="home-button">
     
          <button class="button-60" role="button" onClick={setModalShowHandler} >
            Connect &#8594;
          </button>
          <a className=" cvBtn " href={cv} download> My Resume</a>
          <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
{/* <Contact trigger={contactButton} setTrigger={setContactButton}></Contact> */}

        </div>
      </div>
    </div>
  );
}

export default Home;
